import classNames from 'classnames';
import CloseButton from 'components/buttons/CloseButton';
import SkeletonReview from 'components/ReviewRating/SkeletonReview';
import { AnalyticsContext } from 'contexts/AnalyticsContext';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { useConfig } from 'hooks';
import Link from 'next/link';
import { useContext, useEffect, useRef, useState } from 'react';
import { hideAll } from 'tippy.js';
import { ButtonReviews, Container, Reviews } from './TooltipContent.styled';
import { TooltipContentProps } from './TooltipContent.types';

const TooltipContent = ({ shipData }: TooltipContentProps) => {
	const config = useConfig();

	const { externalUrls } = config;
	const { globalization }: any = useContext(CruiseSearchContext);
	const { generalDictionary } = globalization?.dictionaries || {};
	const { labelReviewsTooltip } = generalDictionary;

	const { utagRatingViewMore }: any = useContext(AnalyticsContext);

	const tippyClasses = classNames({
		rating: true,
	});

	const containerRef = useRef(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const ref = containerRef || { current: undefined };
		const config = { attributes: true, childList: true, subtree: true };

		const handleNodeInserted = (event) => {
			setLoading(true);
			event.map(({ addedNodes }) => {
				if (addedNodes.length && addedNodes[0].querySelector('div[role="group"]')) {
					setLoading(false);
				}
			});
		};

		const observer = new MutationObserver(handleNodeInserted);

		if (ref) {
			observer.observe(ref.current, config);
		}
		return () => {
			observer.disconnect();
		};
	}, [containerRef.current]);

	const shipSegmentUrl = shipData?.name?.toLowerCase().split(' ').join('-');

	return (
		<Container
			onClick={(e) => {
				e.stopPropagation();
			}}
		>
			{!loading && (
				<CloseButton
					onClick={(e) => {
						e.stopPropagation();
						hideAll();
					}}
				/>
			)}
			{<Reviews data-bv-show="review_highlights" data-bv-product-id={shipData?.code} ref={containerRef} />}
			{loading && <SkeletonReview />}
			{!loading && (
				<Link href={`${externalUrls.shipReviews}${shipSegmentUrl}#reviews`} passHref>
					<ButtonReviews
						target="_blank"
						className={tippyClasses}
						onClick={(e) => {
							e.stopPropagation();
							utagRatingViewMore();
						}}
					>
						{labelReviewsTooltip}
					</ButtonReviews>
				</Link>
			)}
		</Container>
	);
};

export default TooltipContent;
